module.exports = __webpack_public_path__ + "img/changecolor.2fbebc6b.svg";